/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, node, func, shape, object } from 'prop-types'
import { jsx, Label, Flex } from 'theme-ui'
import { useField } from 'formik'
import './formInputs.css'
import { ChevronDown } from '../../../icons/index'
import FlatButton from '../Buttons/FlatButton'
import { HelperText, ErrorMessage } from './Common'

// Custom input field that adds Formik functionality to theme-ui's Select, and adds our styling, and icon option.
const SelectField = ({
  buttonIcon,
  buttonDisabled,
  buttonText,
  handleIconClick,
  helperText,
  label,
  customError,
  hideLabel,
  removeMargin,
  containerSX,
  ...props
}) => {
  const [field, meta] = useField(props)
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        width: '100%',
        maxWidth: 323,
        mt: removeMargin ? 0 : 5,
        ...containerSX,
      }}
    >
      {!hideLabel && <Label htmlFor={name}>{label}</Label>}
      <HelperText>{helperText}</HelperText>
      <Flex>
        <Flex sx={{ position: 'relative', width: '100%' }}>
          <select
            {...field}
            {...props}
            sx={{
              variant: 'forms.select',
              bg:
                meta.touched && (meta.error || customError?.showError)
                  ? 'inputError'
                  : !meta.error && meta.value
                  ? 'inputSuccess'
                  : 'inputBackground',
              option: {
                backgroundColor: 'inputBackground',
              },
            }}
            data-automation-id={`select-field-${props.name}`}
          />
          <ChevronDown
            color="darkGray"
            sx={{
              position: 'absolute',
              top: '22px',
              right: '20px',
              pointerEvents: 'none',
            }}
          />
        </Flex>
        {buttonIcon ? (
          <FlatButton
            sx={{
              display: 'flex',
              mt: 3,
              ml: 3,
              flexShrink: 0,
            }}
            buttonStyle="tertiary"
            color="forest"
            size="large"
            leftIcon={buttonIcon}
            disabled={buttonDisabled}
            onClick={handleIconClick}
            onKeyDown={handleIconClick}
            type="button"
          >
            {buttonText}
          </FlatButton>
        ) : null}
      </Flex>
      {meta.touched && (meta.error || customError?.showError) ? (
        <ErrorMessage>
          {meta.error ? meta.error : customError?.errorMessage}
        </ErrorMessage>
      ) : null}
    </Flex>
  )
}

SelectField.propTypes = {
  buttonIcon: node,
  buttonText: string,
  buttonDisabled: bool,
  handleIconClick: func,
  helperText: string,
  hideLabel: bool,
  label: string.isRequired,
  name: string.isRequired,
  customError: shape({
    showError: bool,
    errorMessage: string,
  }),
  removeMargin: bool,
  containerSX: object,
}

export default SelectField
